import { API_NAMES, initApi } from "../../../utils/HttpApiHelper";

const postAccountForgotPasswordData = (username, state, setState) => {
  if (username) {
    const api = initApi(API_NAMES.SECURITY, state, setState);
    const url = `/Account/ForgotPassword`;

    return api?.executeObject ? api.executeObject(url, 'POST', { username }) : null;
  }
};

const AccountForgotPasswordData = {
  postAccountForgotPasswordData
};

export default AccountForgotPasswordData;